export default "__VITE_ASSET__D4u8R5r8__"